import React, { useState, useEffect } from 'react'
import './index.scss'

export default function MediaGrid({ items = [], maxVisible = 5 }) {
  const [openIndex, setOpenIndex] = useState(-1)

  // Giới hạn chỉ render 5 hình, nhưng vẫn tính tổng số
  const visible = items.slice(0, maxVisible)
  const extraCount = Math.max(0, items.length - maxVisible)

  const openAt = (index) => setOpenIndex(index)
  const close = () => setOpenIndex(-1)
  const next = () => setOpenIndex((i) => (i + 1) % items.length)
  const prev = () => setOpenIndex((i) => (i - 1 + items.length) % items.length)

  useEffect(() => {
    const handleKey = (e) => {
      if (openIndex === -1) return
      if (e.key === 'Escape') close()
      if (e.key === 'ArrowRight') next()
      if (e.key === 'ArrowLeft') prev()
    }
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  }, [openIndex])

  const getGridClass = (count) => {
    if (count === 1) return 'grid-1'
    if (count === 2) return 'grid-2'
    if (count === 3) return 'grid-3'
    if (count === 4) return 'grid-4'
    return 'grid-5'
  }

  // 🔹 Nếu có hơn 5 hình, thêm class "has-more" để CSS show overlay đúng chỗ
  const gridClass = `${getGridClass(visible.length)} ${extraCount > 0 ? 'has-more' : ''}`

  return (
    <>
      <div className={`media-grid ${gridClass}`}>
        {visible.map((it, idx) => (
          <div key={it.id ?? it.url ?? idx} className="media-item" onClick={() => openAt(idx)}>
            {it.type === 'IMAGE' ? (
              <img src={it.thumbUrl || it.url} alt="" />
            ) : (
              <>
                {it.thumbUrl ? <img src={it.thumbUrl} alt="video thumb" /> : <video src={it.url} muted preload="metadata" />}
                <div className="video-icon">
                  <span style={{ marginLeft: '2px' }}>▶</span>
                </div>
              </>
            )}

            {/* 🔹 Overlay chỉ xuất hiện ở hình cuối (index 4 = ô thứ 5) khi có extra */}
            {extraCount > 0 && idx === maxVisible - 1 && <div className="overlay-count">+{extraCount}</div>}
          </div>
        ))}
      </div>

      {/* 🔹 Modal xem chi tiết */}
      {openIndex > -1 && (
        <div className="media-modal" onClick={close}>
          <div className="modal-content-grid" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={close}>
              ✕
            </button>

            <button className="nav-btn prev" onClick={prev}>
              ⟨
            </button>
            <button className="nav-btn next" onClick={next}>
              ⟩
            </button>

            <div className="viewer-box">
              {items[openIndex].type === 'IMAGE' ? (
                <img src={items[openIndex].url} alt="full" />
              ) : (
                <video src={items[openIndex].url} controls autoPlay />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
